import { useEffect, useState } from "react";

/**
 * SMSは1通ごとに費用がかかるうえ、連打すると Firebase 側の制限に当たって
 * 正規の利用者まで送れなくなるため、こちら側でも間隔を空ける。
 */
const RESEND_INTERVAL_SECONDS = 60;

export const useRemainingSecondsToResend = (
  lastSentAt: number | null
): number => {
  const [remainingSeconds, setRemainingSeconds] = useState(0);

  useEffect(() => {
    if (lastSentAt === null) {
      setRemainingSeconds(0);
      return;
    }
    const computeRemainingSeconds = () =>
      Math.max(
        0,
        RESEND_INTERVAL_SECONDS - Math.floor((Date.now() - lastSentAt) / 1000)
      );
    setRemainingSeconds(computeRemainingSeconds());
    const timerId = setInterval(() => {
      const nextRemainingSeconds = computeRemainingSeconds();
      setRemainingSeconds(nextRemainingSeconds);
      if (nextRemainingSeconds === 0) {
        clearInterval(timerId);
      }
    }, 1000);
    return () => clearInterval(timerId);
  }, [lastSentAt]);

  return remainingSeconds;
};
